export default __webpack_public_path__ + "static/media/hands-burger.6aa16994.png";